import React from 'react';

import WpCheckbox from '../WpCheckbox';
import WpCheckboxGroup from '../WpCheckboxGroup';
import { WpForm, WpFormLayout } from '../../form';
import WpButton from '../../button/WpButton';

const CheckboxDocs = () => {
  const WithoutForm = () => {
    return (
      <>
        <h5>basic html checkbox</h5>
        <WpCheckbox checked id="checkbox_input" label="Admin" value="admin" descriptionText="Help Text goes here" />
      </>
    );
  };

  const WithForm = () => {
    const handleSubmit = values => {
      alert('Submitted! see console log for submitted data');
      console.log('--values', values);
    };

    return (
      <>
        <h5>With Form</h5>
        <WpForm onSubmit={handleSubmit}>
          <WpFormLayout>
            <WpCheckbox id="email_cb" label="Email" descriptionText="Help Text goes here" />
            <WpCheckbox id="slack_cb" label="Slack" descriptionText="Help Text goes here" />
            <WpButton btnType="submit"> submit</WpButton>
          </WpFormLayout>
        </WpForm>
      </>
    );
  };

  const InGroup = () => {
    const handleSubmit = values => {
      alert('Submitted! see console log for submitted data');
      console.log('--values', values);
    };
    return (
      <>
        <h5>horizontal group</h5>
        <WpForm onSubmit={handleSubmit}>
          <WpCheckboxGroup label="Select all that apply" direction="horizontal">
            <WpCheckbox id="email_cb_1" label="Email" descriptionText="Help Text goes here" />
            <WpCheckbox id="slack_cb_2" label="Slack" descriptionText="Help Text goes here" />
            <WpCheckbox id="slack_cb_3" label="Teams" descriptionText="Help Text goes here" />
          </WpCheckboxGroup>
          <WpButton btnType="submit"> submit</WpButton>
        </WpForm>
      </>
    );
  };

  return (
    <>
      <WithoutForm />
      <hr />
      <WithForm />
      <hr />
      <InGroup />
    </>
  );
};

export default CheckboxDocs;
